import { updateState } from '../../../shared/actions/headerState';

import type { TReduxStore, TThunkDispatch } from '../../../shared/types/redux';

export function updateHeaderHandler(store: TReduxStore) {
  (store.dispatch as TThunkDispatch)(updateState());
}
